/**
 * Canonical role constants for FieldOps.
 *
 * 7 business roles: Admin, Super Admin, Finance, HOD, Coordinator, Employee, CRM
 *
 * Code aliases (finance_officer, service_coordinator) are kept in the database
 * and backend for backwards-compatibility but must NEVER appear as display
 * labels in the UI. super_admin is a real, selectable role (same permissions
 * as admin) and displays as its own label.
 */

export const ROLE_GROUPS = {
  ADMIN:       ["admin", "super_admin"],
  FINANCE:     ["finance", "finance_officer"],
  HOD:         ["supervisor"],
  COORDINATOR: ["coordinator", "service_coordinator"],
  EMPLOYEE:    ["employee"],
  CRM:         ["crm"],
};

/** Map any role string to its canonical business display label. */
export const ROLE_LABELS = {
  admin:               "Admin",
  super_admin:         "Super Admin",
  finance:             "Finance",
  finance_officer:     "Finance",
  supervisor:          "HOD",
  coordinator:         "Coordinator",
  service_coordinator: "Coordinator",
  employee:            "Employee",
  crm:                 "CRM",
};

/** Tailwind color classes per business group. */
export const ROLE_COLORS = {
  admin:               "bg-orange-500",
  super_admin:         "bg-orange-500",
  supervisor:          "bg-blue-500",
  coordinator:         "bg-violet-500",
  service_coordinator: "bg-violet-500",
  finance:             "bg-emerald-500",
  finance_officer:     "bg-emerald-500",
  employee:            "bg-slate-400",
  crm:                 "bg-cyan-500",
};

/** Returns true if the role belongs to the given group. */
export function inGroup(role, group) {
  return (ROLE_GROUPS[group] || []).includes(role);
}

/** Returns the canonical display label for any role string. */
export function roleLabel(role) {
  return ROLE_LABELS[role] || role;
}
